import React from 'react';
import useLang from '../hooks/useLang';

const Impressum = ({ onClose }) => {
  const { lang } = useLang();
  
  const content = {
    de: {
      title: "Impressum",
      tmgTitle: "Angaben gemäß § 5 TMG",
      representedBy: "Vertreten durch:",
      contact: "Kontakt",
      registration: "Registereintrag",
      registrationText: "Eintragung im Handelsregister.",
      registrationCourt: "Registergericht: Amtsgericht Charlottenburg",
      registrationNumber: "Registernummer: HRB 264590 B",
      vatId: "Umsatzsteuer-ID",
      vatIdText: "Umsatzsteuer-Identifikationsnummer gemäß § 27a UStG: DE368386682",
      responsibleContent: "Inhaltlich verantwortlich gemäß § 55 Abs. 2 RStV",
      euDispute: "EU-Streitschlichtung",
      euDisputeText: "Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:",
      emailText: "Unsere E-Mail-Adresse finden Sie oben im Impressum.",
      consumerDispute: "Verbraucherstreitbeilegung/Universalschlichtungsstelle",
      consumerDisputeText: "Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.",
      closeButton: "Schließen"
    },
    es: {
      title: "Aviso Legal",
      tmgTitle: "Información según § 5 TMG",
      representedBy: "Representado por:",
      contact: "Contacto",
      registration: "Registro mercantil",
      registrationText: "Inscripción en el registro mercantil.",
      registrationCourt: "Tribunal de registro: Amtsgericht Charlottenburg",
      registrationNumber: "Número de registro: HRB 264590 B",
      vatId: "ID de IVA",
      vatIdText: "Número de identificación del IVA según § 27a UStG: DE368386682",
      responsibleContent: "Responsable del contenido según § 55 Abs. 2 RStV",
      euDispute: "Resolución de disputas de la UE",
      euDisputeText: "La Comisión Europea proporciona una plataforma para la resolución de disputas en línea (OS):",
      emailText: "Puede encontrar nuestra dirección de correo electrónico arriba en el aviso legal.",
      consumerDispute: "Resolución de disputas del consumidor/Oficina de arbitraje universal",
      consumerDisputeText: "No estamos dispuestos u obligados a participar en procedimientos de resolución de disputas ante una oficina de arbitraje del consumidor.",
      closeButton: "Cerrar"
    },
    it: {
      title: "Colophon",
      tmgTitle: "Informazioni secondo § 5 TMG",
      representedBy: "Rappresentato da:",
      contact: "Contatto",
      registration: "Iscrizione al registro",
      registrationText: "Iscrizione nel registro delle imprese.",
      registrationCourt: "Tribunale del registro: Amtsgericht Charlottenburg",
      registrationNumber: "Numero di registro: HRB 264590 B",
      vatId: "Partita IVA",
      vatIdText: "Numero di identificazione IVA secondo § 27a UStG: DE368386682",
      responsibleContent: "Responsabile del contenuto secondo § 55 Abs. 2 RStV",
      euDispute: "Risoluzione delle controversie UE",
      euDisputeText: "La Commissione Europea fornisce una piattaforma per la risoluzione delle controversie online (OS):",
      emailText: "Puoi trovare il nostro indirizzo email sopra nel colophon.",
      consumerDispute: "Risoluzione delle controversie dei consumatori/Ufficio di arbitrato universale",
      consumerDisputeText: "Non siamo disposti o obbligati a partecipare a procedure di risoluzione delle controversie davanti a un ufficio di arbitrato dei consumatori.",
      closeButton: "Chiudi"
    }
  };

  const t = content[lang] || content.de;
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg max-w-4xl max-h-[90vh] overflow-y-auto p-6">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-2xl font-bold text-gray-900">{t.title}</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 text-2xl font-bold"
          >
            ×
          </button>
        </div>
        
        <div className="prose max-w-none">
          <h3 className="text-lg font-semibold mb-3">{t.tmgTitle}</h3>
          
          <div className="mb-6">
            <p className="font-medium">Lazzaro One UG (haftungsbeschränkt)</p>
            <p>Forckenbeckstraße 63c</p>
            <p>14199 Berlin</p>
            <p>Deutschland</p>
          </div>

          <div className="mb-6">
            <p><strong>{t.representedBy}</strong> Arsenio Longo (Geschäftsführer)</p>
          </div>

          <div className="mb-6">
            <h4 className="font-semibold mb-2">{t.contact}</h4>
            <p>Telefon: +49 (0)30 24618457</p>
            <p>E-Mail: office@lazzaro.one</p>
          </div>

          <div className="mb-6">
            <h4 className="font-semibold mb-2">{t.registration}</h4>
            <p>{t.registrationText}</p>
            <p>{t.registrationCourt}</p>
            <p>{t.registrationNumber}</p>
          </div>

          <div className="mb-6">
            <h4 className="font-semibold mb-2">{t.vatId}</h4>
            <p>{t.vatIdText}</p>
          </div>

          <div className="mb-6">
            <h4 className="font-semibold mb-2">{t.responsibleContent}</h4>
            <p>Arsenio Longo</p>
            <p>Forckenbeckstraße 63c</p>
            <p>14199 Berlin</p>
          </div>

          <div className="mb-6">
            <h4 className="font-semibold mb-2">{t.euDispute}</h4>
            <p>
              {t.euDisputeText}
              <a 
                href="https://ec.europa.eu/consumers/odr" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-blue-600 hover:text-blue-800 ml-1"
              >
                https://ec.europa.eu/consumers/odr
              </a>
            </p>
            <p className="mt-2">{t.emailText}</p>
          </div>

          <div className="mb-6">
            <h4 className="font-semibold mb-2">{t.consumerDispute}</h4>
            <p>{t.consumerDisputeText}</p>
          </div>
        </div>

        <div className="mt-6 flex justify-end">
          <button
            onClick={onClose}
            className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
          >
            {t.closeButton}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Impressum;